import { useContext, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import PageRefreshContext from "../context/PageRefreshContext";

/** Register this page's refetch logic for the global refresh button. */
export const usePageRefresh = (refetch, deps = []) => {
  const { pathname } = useLocation();
  const ctx = useContext(PageRefreshContext);
  const refetchRef = useRef(refetch);
  refetchRef.current = refetch;

  useEffect(() => {
    if (!ctx?.register) return undefined;
    return ctx.register(pathname, async () => {
      await refetchRef.current?.();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ctx, pathname, ...deps]);
};

/** Listen for global refresh when no handler is registered. */
export const usePageRefreshListener = (refetch, deps = []) => {
  const { pathname } = useLocation();
  const refetchRef = useRef(refetch);
  refetchRef.current = refetch;

  useEffect(() => {
    const onRefresh = (event) => {
      if (event?.detail?.pathname !== pathname) return;
      refetchRef.current?.();
    };
    window.addEventListener("icd:page-refresh", onRefresh);
    return () => window.removeEventListener("icd:page-refresh", onRefresh);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, ...deps]);
};
